module.exports = __webpack_public_path__ + "img/brown-hairy-grass-01.b6a23b62.png";